/**
 * Possible shipment status from the back end
 */
export const ShipmentStatus = {
    NEW: 'new',
    READY_TO_BE_SHIPPED: 'ready_to_be_shipped',
    SHIPPED: 'shipped',
    CC_TRANSIT: 'cc_transit'
}
